import dayjs from "dayjs";

export const getFullDate = (date: string): string => {
    return dayjs(date).format("YYYY-MM-DD");
};
export const getFullDateTime = (date: string): string => {
    return dayjs(date).format("YYYY-MM-DD HH:MM");
};